import worldCupBg from '../assets/checkout-world-cup-bg.jpg';
import worldCupBg2 from '../assets/checkout-world-cup-bg-2.jpg';
import concertBg from '../assets/checkout-concert-bg.jpg';
import stadiumBg from '../assets/checkout-stadium-bg.jpg';

/** @type {Record<string, { src: string, theme?: 'sports' | 'concert' }>} */
export const CHECKOUT_V2_BACKGROUNDS = {
  'checkout-world-cup-bg.jpg': { src: worldCupBg, theme: 'sports' },
  'checkout-world-cup-bg-2.jpg': { src: worldCupBg2, theme: 'sports' },
  'checkout-concert-bg.jpg': { src: concertBg, theme: 'concert' },
  'checkout-stadium-bg.jpg': { src: stadiumBg, theme: 'sports' },
};

/**
 * @param {string} url
 * @returns {boolean}
 */
function isValidBackgroundUrl(url) {
  try {
    const parsed = new URL(url);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:';
  } catch {
    return false;
  }
}

/**
 * @param {URLSearchParams} searchParams
 * @returns {{ src: string, theme?: 'sports' | 'concert' } | null}
 */
export function getCheckoutV2Background(searchParams) {
  const backgroundUrl = searchParams.get('background_url');
  if (backgroundUrl && isValidBackgroundUrl(backgroundUrl)) {
    return { src: backgroundUrl };
  }

  const key = searchParams.get('background');
  if (!key) return null;
  return CHECKOUT_V2_BACKGROUNDS[key] ?? null;
}
